(function () {
  'use strict';
  function initCollapsible(root) {
    var body = root.querySelector('[data-cseo-collapsible]');
    var toggle = root.querySelector('[data-cseo-toggle]');
    if (!body || !toggle) return;
    var maxH = parseInt(body.getAttribute('data-max-height'), 10) || 180;
    if (body.scrollHeight <= maxH + 40) return;
    body.style.maxHeight = maxH + 'px';
    body.classList.add('creslia-collection-seo__body--collapsed');
    toggle.classList.add('creslia-collection-seo__toggle--visible');
    var collapsed = true;
    var moreLabel = toggle.getAttribute('data-more') || 'Read More';
    var lessLabel = toggle.getAttribute('data-less') || 'Show Less';
    toggle.textContent = moreLabel;
    toggle.addEventListener('click', function () {
      if (collapsed) {
        body.style.maxHeight = body.scrollHeight + 'px';
        body.classList.remove('creslia-collection-seo__body--collapsed');
        toggle.textContent = lessLabel;
      } else {
        body.style.maxHeight = maxH + 'px';
        body.classList.add('creslia-collection-seo__body--collapsed');
        toggle.textContent = moreLabel;
      }
      collapsed = !collapsed;
    });
  }
  function init() {
    var nodes = document.querySelectorAll('[data-creslia-collection-seo]');
    for (var i = 0; i < nodes.length; i++) initCollapsible(nodes[i]);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
